module.exports = __webpack_public_path__ + "img/magnit_cos.459c9f38.png";